import { createTheme, ThemeProvider } from '@mui/material/styles';

// Create a theme with your custom font family
const theme = createTheme({
  typography: {
    fontFamily: 'Nunito Sans, sans-serif',
  },
});

export default theme;